<template>
  <pf-toggle-group>
    <pf-toggle-group-item :selected="modelValue === true" @click="emit('update:modelValue', true)" data-ouia-component-id="annual-invoicing-toggle">
      <template #icon><calendar-days-icon /></template>
      {{ $t('Annuale: risparmia 2 mensilità') }}
    </pf-toggle-group-item>
    <pf-toggle-group-item :selected="modelValue === false" @click="emit('update:modelValue', false)" data-ouia-component-id="monthly-invoicing-toggle">
      <template #icon><calendar-day-icon /></template>
      {{ $t('Mensile') }}
    </pf-toggle-group-item>
  </pf-toggle-group>
</template>

<script setup lang="ts">
import { useWizardQuestion } from '@/wizard';
import CalendarDaysIcon from '@vue-patternfly/icons/calendar-days-icon';
import CalendarDayIcon from '@vue-patternfly/icons/calendar-day-icon';

defineProps<{
  modelValue: boolean;
}>();

const emit = defineEmits<{
  (name: 'update:modelValue', v: boolean): void;
}>();

useWizardQuestion();
</script>
